/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 静脈確保タイミング
 */
export type TreatmentIvAccessTimingEnum =
  (typeof TreatmentIvAccessTimingEnum)[keyof typeof TreatmentIvAccessTimingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentIvAccessTimingEnum = {
  PRE_CPA: 'PRE_CPA',
  POST_CPA: 'POST_CPA',
  GLUCOSE: 'GLUCOSE',
  CPA: 'CPA',
  SHOCK: 'SHOCK',
  CRASH: 'CRASH',
} as const;
